//document.addEventListener("DOMContentLoaded", function () {
//  // Find the first element with the "engravingfont" class
//  const engravingFontElement = document.querySelector(".engravingfont");
//
//  // Check if the element was found
//  if (engravingFontElement) {
//    // Simulate a click on the element
//    engravingFontElement.click();
//  } else {
//    console.log("Element with class 'engravingfont' not found.");
//  }
// });


function markRequired() {
    var control = $(this).children(".text");
    var label = $(this).children("label");
    if (control.attr("required") == "required") {
        label.addClass("required");
    }
}

//Odpri in zapri Customize field

function showImage() {
   if (imagediv.style.display == "none") {
        imagediv.style.display = "block";
        $(".showtext").css("backgroundColor", "#eee");
   } else {
        imagediv.style.display = "none";
        $(".showtext").css("backgroundColor", "transparent");
    }


  //Za font izbrat
   if (textengraving2.style.display == "none") {
        textengraving2.style.display = "block";
    } else {
        textengraving2.style.display = "none";
    }
}

function showText() {
//   if (textengraving.style.display == "none") {
//      if( $('input[type=radio][id="Poppins-Light1"]').is(':checked') ){
//       //
//      } else {
//       $('input[type=radio][id="Poppins-Light"]').click();
//      }
//       textengraving.style.display = "block";
//        $(".showtext").css("backgroundColor", "#eee");
//   } else {
//        textengraving.style.display = "none";
//        $(".showtext").css("backgroundColor", "transparent");
//    }


  //Za font izbrat
   if (textengraving2.style.display == "none") {
        textengraving2.style.display = "block";
    } else {
        textengraving2.style.display = "none";
    }
}

//Bold ni nič

function Bold() {
$( "div span:first-child" )
  .css( "text-decoration", "underline" )
  .hover(function() {
    $( this ).addClass( "sogreen" );
  }, function() {
    $( this ).removeClass( "sogreen" );
  });
}

//Pokaže preview slike

function readURL(input) {
      if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
             $('#pic').attr('src', e.target.result);
             var picbuttons = document.getElementById('picbuttons').style.display = "block";
             var picshow = document.getElementById('pic').style.display = "block";
        };

        reader.readAsDataURL(input.files[0]);
   }
}

// function redError() {
//    var max = $(this).attr("maxlength");
//    var length = $(this).val().length;
//    var counter = max - length;
  //console.log(counter)
//    var redfield = $(".text");
  //console.log(helper2)
    // Make it red if there are 0 characters remaining
//    if (counter === 0) {
//        redfield.removeClass("text-muted");
//        redfield.addClass("text-danger");
//    } else {
//        redfield.removeClass("text-danger");
//        redfield.addClass("text-muted");
//    }
//}

//Preview scroll to the top


function preview() {
  $("html, body").animate({ scrollTop: 0 }, "slow");
  return false;
}

//Clearfields počisti vse

function ClearFields() {
    var cleartext = document.getElementById("cleartext").value = "";
    for (var i = 0; i < cleartext.length; i++) {
        cleartext[i].innerHTML = 'Engravable';
    }
    console.log(cleartext)
    var max = $('.text').attr("maxlength");
    var helper = $(".form-text");
    helper.removeClass("text-danger");
    helper.addClass("text-muted");
    helper.text(max + " characters remaining");
    var showText = document.getElementById('textengraving').style.display = "none";
    var showText = document.getElementById('textengraving2').style.display = "none";
    $(".showtext").css("backgroundColor", "transparent");
    $('#fontengravingfamily').val('');
    $('#fontengravingfamily').attr('name', '');
    $('.engravingfont:checked').prop('checked', false);

  
    $('.custom').removeClass("Patra");
    $('input[type=radio][id="lucidaFont"]').removeAttr("checked");
    $('input[type=radio][id="chasingWavesFont"]').removeAttr("checked");
}

//Character count

// Allow only text with uppercase


function validateInput(inputElement) {
    let inputValue = inputElement.value;
    inputValue = inputValue.toUpperCase();

    // Remove emojis using a regex pattern
    inputValue = inputValue.replace(/[\uD800-\uDFFF]./g, '');

    inputElement.value = inputValue;
}




